/* LegBilligt — KURVTALLET I HOEJRE HJOERNE OPDATERES ALTID, PAA ALLE SIDER
   Hentes af snippets/doc-head-core.liquid.

   Jakob 4. september: "har lagt 3 i kurven her ude paa siden her, kurven oppe
   i hoejre hjoerne opdateres ikke instant. det skal den. kurven skal altid og
   alle sider opdateres instant."

   HVORFOR DET IKKE VIRKEDE: temaets assets/product-form.js opdaterer kun
   ikonet, naar en vare LAEGGES i kurven (handleSubmit -> updateCartIcon).
   Naar kunden derefter taeller op eller ned paa produktkortets antalsvaelger,
   koerer updateQuantity() — og den rammer /cart/change uden at roere ikonet
   overhovedet. Tallet blev staaende, til siden blev hentet igen.

   LOESNINGEN er ikke at rette i hver enkelt knap, men at lytte ét sted:
   alle veje til en aendret kurv ender i et kald til /cart/add, /cart/change,
   /cart/update eller /cart/clear. Vi pakker window.fetch ind, og naar et af
   dem er faerdigt, henter vi ikonets egen sektion forfra og skifter tallet.
   Saa virker det ogsaa for knapper, vi ikke kender endnu.

   HVORFOR /cart?section_id= OG IKKE /?section_id=: maalt 4. september svarede
   forsiden med et FORAELDET tal (1, mens kurven havde 2), fordi forsiden er
   cachet. /cart er aldrig cachet — den skal jo vise kundens egen kurv.

   Ingen MutationObserver. */
(function(){
  if (!window.fetch) { return; }

  var koerer = false, igen = false;

  function hentTal(){
    if (koerer) { igen = true; return; }
    var boble = document.getElementById('cart-icon-bubble');
    if (!boble) { return; }
    koerer = true;

    fetch('/cart?section_id=cart-icon-bubble', {headers: {'Accept': 'text/html'}})
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(html){
        if (html === null) { return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ny = doc.getElementById('shopify-section-cart-icon-bubble');
        /* Sektionen svarer med sin egen ydre kasse. Vi vil kun have
           indholdet — ellers faar vi en kasse inde i en kasse for hver
           opdatering. */
        boble.innerHTML = ny ? ny.innerHTML : html;
      })
      .catch(function(){})
      .then(function(){
        koerer = false;
        if (igen){ igen = false; hentTal(); }
      });
  }

  var oprindelig = window.fetch;
  window.fetch = function(){
    var svar = oprindelig.apply(this, arguments);
    try {
      var u = arguments[0];
      if (u && typeof u !== 'string' && u.url) { u = u.url; }
      if (typeof u === 'string' &&
          (u.indexOf('/cart/add') > -1 ||
           u.indexOf('/cart/change') > -1 ||
           u.indexOf('/cart/update') > -1 ||
           u.indexOf('/cart/clear') > -1)){
        if (svar && svar.then) { svar.then(function(){ hentTal(); }, function(){}); }
      }
    } catch(e){}
    return svar;
  };

  /* Kommer kunden tilbage til en fane, hun har haft liggende, kan kurven
     vaere aendret i en anden fane. Saa er tallet ogsaa forkert. */
  document.addEventListener('visibilitychange', function(){
    if (!document.hidden) { hentTal(); }
  });
})();